// This is a TypeGen auto-generated file. Changes will be lost when this file is regenerated.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export enum SpErrorCode {
    Generic = 0,
    Validation = 1,
    NotFound = 2,
    DataFilteringError = 3,
    NotAuthenticated = 4,
    FormSubmissionError = 5,
    NotAllowed = 6,
    FileManagement = 7,
    UploadFileNotAllowed = 8,
    JwtOutdated = 9,
    GenericList = 10,
    EmailFailure = 11,
    DataAttributeManagement = 12,
    Duplicate = 13,
    Solicitation = 14,
    StepManagement = 15,
    RequirementManagement = 16,
    TaskManagement = 17,
    ToDoItemManagement = 18,
    WorkflowManagement = 19,
    MemberSubmissionManagement = 20,
    EvaluationManagement = 21,
    FormManagement = 22,
    AwardManagement = 23,
    UserDisabled = 24,
    LaunchReadinessBlocked = 25,
}
